import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
} from '@occc/ui-design-system';
import { RetailerNetworkLocationGroupFragment } from '@occc/graphql';

import { RetailerNetworkUserDetailsLocationGroupsTableRow } from './retailer-network-user-details-location-groups-table-row.component';

import { useGetRetailerNetworkLocationGroups } from '../../../../data-access/queries';

type RetailerNetworkUserDetailsLocationGroupsTableProps = {
  locationGroupsData: ReturnType<typeof useGetRetailerNetworkLocationGroups>;
  handleOpenLocationGroupDetailsPage: (locationUuid: string) => void;
  handleRemoveUserFromLocationGroup: (locationGroupUuid: string) => void;
  isCurrentUserPermittedToDisassociate: boolean;
};

export const RetailerNetworkUserDetailsLocationGroupsTable = ({
  locationGroupsData,
  handleOpenLocationGroupDetailsPage,
  handleRemoveUserFromLocationGroup,
  isCurrentUserPermittedToDisassociate,
}: RetailerNetworkUserDetailsLocationGroupsTableProps) => {
  const { loading: locationsLoading, error, data, paginationProps } = locationGroupsData;

  const renderData = (items: RetailerNetworkLocationGroupFragment[]) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Group Name</TableCell>
            <TableCell>Locations</TableCell>
            <TableCell align='right'>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((locationGroup) => (
            <RetailerNetworkUserDetailsLocationGroupsTableRow
              key={locationGroup.uuid}
              locationGroup={locationGroup}
              handleOpenLocationGroupDetailsPage={handleOpenLocationGroupDetailsPage}
              handleRemoveUserFromLocationGroup={handleRemoveUserFromLocationGroup}
              isCurrentUserPermittedToDisassociate={isCurrentUserPermittedToDisassociate}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </TableContainer>
  );

  return (
    <LoadedContent<RetailerNetworkLocationGroupFragment>
      error={error}
      loading={locationsLoading}
      items={data}
      renderData={renderData}
    />
  );
};
